export default {"src":"/_next/static/media/service-card-chevron-right-icon.96b7ae19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};